export default __webpack_public_path__ + "static/fantastika_logo-24bb43e9fae2176f91df7a8a8789502f.png";